module.exports = __webpack_public_path__ + "static/img/yesterdayMvp.7b550e8d.png";